(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const collectionUrl = new URL(window.location.href);
  if (collectionUrl.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const targetCard = document.getElementById(collectionUrl.hash.slice(1));
      if (targetCard) {
        targetCard.scrollIntoView({ behavior: 'instant' });
      }
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
